import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ForexRatesProvider } from './contexts/ForexRatesContext';
import LiveDashboard from './components/dashboard/LiveDashboard';
import Terminal from './components/terminal/Terminal';
import AuditPage from './components/audit/AuditPage';
import './styles/globals.css';

function App() {
  return (
    <ForexRatesProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<LiveDashboard />} />
        <Route path="/terminal" element={<Terminal />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
    </ForexRatesProvider>
  );
}

export default App;
